module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SG-4b1b57edd297420b568824535bf590d8.png";